import type { Translations } from "./index";

export const pt: Translations = {
  seo: {
    landing: {
      title: "Minuta — IA para reuniões em inglês, português e espanhol",
      description:
        "Minuta escuta a call, entende quando a pergunta é pra você e sugere uma resposta em inglês, português ou espanhol em poucos segundos. Grátis por 7 dias; Founding 100 disponível.",
    },
    downloads: {
      title: "Baixar Minuta para macOS e Windows",
      description:
        "Baixe o app Minuta para macOS e Windows. Captura de áudio local, transcrição rápida em nuvem, tradução em tempo real, ata automática e copiloto de IA dentro da reunião.",
    },
    signup: { title: "Criar sua conta", description: "Crie sua conta grátis do Minuta." },
    confirm: { title: "Confirmar seu email", description: "Confirme seu email para concluir o cadastro do Minuta." },
    done: { title: "Conta pronta", description: "Sua conta Minuta está pronta." },
    login: { title: "Entrar", description: "Entre na sua conta Minuta." },
    account: { title: "Minha conta", description: "Sua conta Minuta e o plano atual." },
    billingDone: { title: "Pagamento concluído", description: "Seu plano Pro do Minuta está sendo ativado." },
    billingCancelled: { title: "Compra cancelada", description: "Sua compra do Minuta foi cancelada." },
    launch: {
      title: "Minuta no Product Hunt — 30% off no Pro pra sempre",
      description:
        "Pare de travar quando a pergunta chega. Copiloto multilíngue de reunião sem bot pra Mac. 30% off no Pro com código HUNT30 — só no dia do Product Hunt.",
      ogImage: "/og/launch-pt.png",
    },
    privacy: {
      title: "Política de Privacidade",
      description:
        "Como o Minuta trata os dados da sua reunião: captura de áudio local e processamento seguro em nuvem com política de retenção limitada.",
    },
    terms: {
      title: "Termos de Serviço",
      description:
        "Termos de serviço para usar o Minuta — copiloto de IA para reuniões no macOS e Windows. Conta, assinatura, uso aceitável e limitação de responsabilidade.",
    },
  },
  nav: {
    copilot: "Copiloto",
    howItWorks: "Como funciona",
    pricing: "Preços",
    faq: "FAQ",
    blog: "Blog",
    signIn: "Entrar",
    getStarted: "Começar grátis",
  },
  cookieConsent: {
    ariaLabel: "Consentimento de cookies",
    kicker: "Escolha de privacidade",
    title: "Cookies e privacidade",
    body:
      "Usamos armazenamento essencial para operar o site e, só com seu consentimento, cookies ou tecnologias similares opcionais para medir o produto e apoiar o checkout. Esta escolha atende LGPD e RGPD para visitantes no Brasil e na Europa.",
    privacyLink: "Leia a política de privacidade",
    reject: "Recusar",
    accept: "Aceitar",
  },
  hero: {
    badge: "Copiloto ao vivo · reuniões EN/PT/ES · sem bot",
    h1Line1: "O Minuta escuta a call.",
    h1Line2: "Você sabe o que responder.",
    description:
      "No instante em que a pergunta é pra você, o Minuta detecta o idioma e monta uma resposta clara em inglês, português ou espanhol — fundamentada nos seus documentos e em tudo que já foi dito. Você lê e fala com confiança.",
    ctaPrimary: "Baixar trial grátis",
    ctaPrimarySub: "macOS · Windows",
    ctaSecondary: "Ver o copiloto",
    ctaSecondarySub: "pergunta → resposta",
    footnote: "macOS · Windows · grátis por 7 dias · Founding 100 nas primeiras 100 vagas (12 meses travado)",
  },
  whereAudioGoes: {
    label: "Camada de confiança",
    heading: "Captura local. Cadeia de IA em nuvem. Sem bot na reunião.",
    description:
      "O Minuta continua sendo um app desktop para captura de áudio do sistema, enviando o mínimo necessário por caminhos seguros em nuvem para transcrição, resumos, ID de falantes e respostas do copiloto.",
    privateLink: "Política de privacidade",
    noBotLink: "Setup sem bot",
    steps: [
      {
        title: "Seu computador captura a chamada",
        body: "Zoom, Teams, Google Meet e chamadas no navegador funcionam normalmente. O Minuta escuta pela sua máquina; nada entra como participante.",
      },
      {
        title: "Cadeia de IA em nuvem processa o áudio",
        body: "Deepgram transcreve o áudio (OpenAI Whisper e Groq entram como fallback automático). OpenAI redige resumos e respostas do copiloto (Anthropic Claude Haiku e Groq como fallback). Modal roda pyannote para detectar quem fala. Os payloads são estreitos e revisados em código.",
      },
      {
        title: "Você guarda o registro útil",
        body: "O transcript, etiquetas de falantes, resumo e respostas do copiloto ficam localmente no app desktop — prontos para revisar, exportar ou apagar.",
      },
    ],
    caveat:
      "O áudio é capturado localmente, processado por uma cadeia multi-provedor de nuvem revisada e salvo de volta no app desktop.",
  },
  leadMagnet: {
    badge: "Íman de leads",
    heading: "Receba os 5 truques práticos para performar melhor em calls técnicas em inglês",
    description:
      "Um playbook curto e direto para engenheiros, consultores e sales engineers ESL: o que preparar antes da reunião, como destravar quando der branco e como responder com clareza sob pressão.",
    emailLabel: "Email de trabalho",
    emailPlaceholder: "voce@empresa.com",
    cta: "Quero receber o guia",
    ctaLoading: "Enviando...",
    privacyNote: "Usamos seu email só para este guia e atualizações do Minuta. Você pode sair quando quiser.",
    success: "Guia solicitado. Confira sua caixa de entrada nos próximos minutos.",
    error: "Não conseguimos enviar seu email agora. Tente novamente em instantes.",
    invalidEmail: "Digite um endereço de email válido.",
  },
  showcase: {
    slides: [
      {
        tag: "Sem bot na call",
        heading: "O Minuta fica na sua tela, não na lista de participantes",
        body: "Use em Google Meet, Zoom ou Teams sem adicionar um notetaker à reunião. O app escuta pelo desktop e fica acessível enquanto a conversa acontece.",
        alt: "Google Meet aberto com o mini controle do Minuta ouvindo a reunião sem adicionar bot à chamada.",
      },
      {
        tag: "Copiloto ao vivo",
        heading: "A pergunta aparece. A resposta também.",
        body: "Quando alguém faz uma pergunta difícil em inglês, português ou espanhol, o Minuta detecta o trecho e sugere uma resposta clara para você ler, ajustar ou responder na hora.",
        alt: "Painel ao vivo do Minuta sobre uma chamada do Google Meet, com pergunta detectada e resposta sugerida pelo copiloto.",
      },
      {
        tag: "Antes da reunião",
        heading: "Prepare idioma, contexto e captura antes da call",
        body: "Abra o Minuta antes da reunião, escolha o idioma, ligue tradução se precisar e adicione contexto para o copiloto responder com mais precisão.",
        alt: "Tela inicial do Minuta para configurar sessão, idioma, tradução, microfone e contexto antes de começar a ouvir.",
      },
    ],
  },
  problem: {
    heading: "Você sabe do que está falando. Só nem sempre aparece na hora.",
    body1:
      "Você está numa call com cliente. Perguntam algo específico sobre uma stack que você já entregou dezenas de vezes — e o nome do serviço simplesmente não vem. Ou você está explicando uma arquitetura e sabe que tem um jeito mais claro de dizer, mas sob pressão sai confuso.",
    body2:
      "Não é falta de conhecimento. É o atrito entre saber e performar em tempo real.",
  },
  englishBarrier: {
    label: "Reuniões multilíngues",
    heading: "Você entende o assunto. Agora responda no idioma da sala.",
    body1:
      "O seu julgamento técnico já está lá. O momento difícil é ao vivo: alguém pergunta em inglês, português ou espanhol, a sala espera, e você precisa responder com clareza antes da conversa andar.",
    body2:
      "O Minuta fecha essa lacuna com transcrição em tempo real, tradução opcional entre inglês, português e espanhol, e uma sugestão de resposta que você lê e fala com confiança no idioma certo.",
    bullets: [
      "Tradução ao vivo entre inglês, português e espanhol enquanto o outro lado fala",
      "Não pegou uma frase? O transcript tá ali — rola pra cima sem quebrar a call",
      "Copiloto monta a resposta no idioma da reunião, no seu nível técnico",
      "Funciona em Zoom, Teams, Google Meet — sem bot na call, ninguém vê",
    ],
  },
  useCases: {
    label: "Casos de uso",
    heading: "A pergunta chega. A resposta já começa a aparecer.",
    subheading:
      "Momentos reais de call técnica em inglês, português e espanhol — e o que o copiloto sugere você responder.",
    saidLabel: "Perguntaram:",
    sayLabel: "Diga isso:",
    items: [
      {
        tab: "Call técnica",
        scenario: "No meio da call, o cliente faz uma pergunta específica de arquitetura.",
        said: "How would you handle retries and idempotency if that payment webhook fires twice?",
        say: "I'd make the handler idempotent — key each event by its provider ID and skip anything already processed. Retries become safe by design: a double-fire just hits the dedup check. I set this up on a billing integration last year.",
      },
      {
        tab: "Demo / objeção",
        scenario: "Durante a demo, o cliente compara o produto com o concorrente.",
        said: "This looks fine, but Competitor X already does it and we're not paying extra for that.",
        say: "Fair — the overlap is real. The difference is where it runs: ours keeps the data on your side and never adds a bot to the call. If that's not a constraint for you, X is reasonable; if it is, that's the line.",
      },
      {
        tab: "Sync com o time",
        scenario: "Sync com o time gringo. Perguntam o status e você responde na hora.",
        said: "Where are we on the migration — is it still on track for this sprint?",
        say: "The migration is on track. Schema changes are merged and tested; what's left is the backfill, which runs tonight. If it comes back clean, we close this tomorrow — no blockers right now.",
      },
    ],
  },
  features: {
    label: "Por baixo dos panos",
    heading: "Leve, silencioso e rápido.",
    items: [
      {
        title: "Processamento rápido em nuvem",
        description:
          "A captura de áudio fica local, mas a transcrição, ID de falantes e copiloto rodam via APIs seguras com retenção limitada. Sem modelos gigantes pesando no seu computador.",
        tag: "Velocidade",
      },
      {
        title: "Transcreve, traduz e identifica falantes",
        description:
          "Detecta voz em tempo real, transcreve automaticamente em inglês, português e espanhol, e traduz quando você precisa de um segundo idioma na tela. Ao encerrar, identifica quem falou cada trecho — sem nenhuma etapa manual.",
        tag: "Pipeline",
      },
      {
        title: "Ata automática com resumo e tarefas",
        description:
          "Assim que você para a gravação, a IA gera uma ata completa: resumo executivo, pontos-chave e action items identificados. Pronto para colar no Notion, Obsidian ou e-mail.",
        tag: "Saída",
      },
    ],
  },
  copilot: {
    badge: "Exclusivo do Pro",
    heading: "Seu copiloto dentro da reunião",
    description:
      "Esta é a principal função do Minuta. O copiloto escuta a reunião e detecta automaticamente quando uma pergunta é dirigida a você. Com um clique, receba uma sugestão de resposta fundamentada nos seus documentos, no que já foi dito na reunião e em buscas em tempo real na web. Disponível apenas no plano Pro.",
    bullets: [
      "Detecta perguntas automaticamente no transcript ao vivo",
      "Respostas baseadas nos seus documentos + transcript da reunião",
      "Busca na web em tempo real para enriquecer a resposta (opcional)",
      "Carregue PDFs, notas ou textos como contexto antes de começar",
    ],
    mockup: {
      barLabel: "Copiloto",
      liveLabel: "Transcript ao vivo",
      questionBadge: "Pergunta detectada",
      ctaButton: "O que responder",
      responseBadge: "Sugestão de resposta",
      addFile: "Adicionar arquivo",
      sourcesLabel: "Fontes:",
      transcript: [
        { time: "14:21", speaker: "Maria", text: "Vamos revisar os próximos passos da proposta." },
        { time: "14:38", speaker: "Carlos", text: "O prazo que você mencionou antes ainda vale?" },
      ],
      detectedQ: {
        time: "14:52",
        speaker: "João",
        text: "Quais são os diferenciais do produto em relação ao concorrente X?",
      },
      responseText:
        "Com base na proposta carregada e no que foi discutido, você pode destacar: integração nativa com as ferramentas existentes, suporte dedicado incluso em todos os planos e o desconto de volume já mencionado que se aplica aqui.",
      chatSources: ["proposta.pdf", "transcript", "busca web"],
    },
  },
  differentiation: {
    label: "Por que Minuta",
    heading: "Isto não é mais um notetaker com IA.",
    items: [
      {
        tag: "Contexto profundo",
        title: "Seu perfil, não leitura genérica de currículo",
        description:
          "Outros copilotos te dão resposta de Wikipedia. O Minuta fala a partir do que você sabe, do que você já construiu e de como você realmente explica as coisas.",
      },
      {
        tag: "Invisível",
        title: "Sem bot, sem interrupção",
        description:
          "Nada entra na sua reunião. O outro lado não vê nada. É só pra você, na sua tela — inclusive durante o screen share.",
      },
      {
        tag: "Calls técnicas",
        title: "Feito pra quem vive em call técnica",
        description:
          "Consultores, engenheiros, arquitetos, sales engineers. Se o seu trabalho é explicar coisa complexa ao vivo, o Minuta foi desenhado pra você.",
      },
    ],
  },
  howItWorks: {
    label: "Como funciona",
    heading: "Três passos. Depois é só aparecer na reunião.",
    steps: [
      {
        n: "01",
        title: "Conta pro Minuta quem você é",
        body: "Suba o seu currículo, seus projetos, a sua stack e qualquer doc que importa. Quanto mais contexto, mais afiada a resposta. Tudo guardado no seu perfil.",
      },
      {
        n: "02",
        title: "Abra o Minuta antes da call",
        body: "Funciona com Zoom, Google Meet, Teams ou qualquer plataforma. Nenhum bot entra na reunião. Invisível durante o screen share.",
      },
      {
        n: "03",
        title: "Receba respostas no seu nível",
        body: "Quando aparece uma pergunta, o Minuta sugere uma resposta no seu tom, com a sua experiência, na sua área técnica. Olha, ajusta, responde.",
      },
    ],
  },
  personas: {
    label: "Pra quem é",
    heading: "Quem está usando o Minuta.",
    items: [
      {
        title: "Consultores técnicos & freelancers",
        description:
          "Discovery calls, revisões de arquitetura, code walkthroughs. O Minuta traz o contexto dos seus projetos passados pro momento certo.",
      },
      {
        title: "Tech leads & engineering managers",
        description:
          "1:1s, reviews de performance, reuniões de planejamento. Menos \"depois te volto\", mais resposta direta.",
      },
      {
        title: "Sales engineers",
        description:
          "Demos técnicas em que uma pergunta pode matar um deal. O Minuta mantém seus battlecards na ponta dos dedos.",
      },
    ],
  },
  privacy: {
    label: "Privacidade",
    heading: "O que é dito na sua call fica com você.",
    bullets: [
      "A transcrição principal roda de forma segura com APIs transientes",
      "Seus dados nunca são usados pra treinar modelos",
      "Apague tudo com um clique",
      "Busca web, tradução, conta e cobrança podem usar serviços externos quando ativados",
    ],
  },
  pricing: {
    label: "Planos",
    heading: "Toda conta começa com 7 dias de acesso completo.",
    description:
      "Cadastros novos liberam tudo — copiloto, ata, identificação de falantes — pelos primeiros 7 dias. Depois, o Free inclui 1 hora/mês de transcrição e tradução seguras. O Pro libera gravação ilimitada, copiloto, atas, identificação de falantes e contexto pessoal. Nenhum áudio sai do seu computador.",
    free: {
      label: "Free",
      period: "1 hora / mês",
      tagline: "7 dias com acesso completo. Depois, 1 hora/mês de transcrição e tradução locais.",
      features: [
        "7 dias com tudo desbloqueado — copiloto, ata, identificação de falantes",
        "1 hora/mês de transcrição e tradução seguras após o trial",
        "Gravações e transcrições ficam no seu computador",
        "Export para Markdown / Obsidian",
        "Sem cartão de crédito",
      ],
      cta: "Começar o trial de 7 dias",
    },
    pro: {
      label: "Pro",
      period: "/ mês",
      tagline: "Mantenha copiloto, ata e identificação de falantes depois do trial. Cancele quando quiser.",
      badge: "Recomendado",
      features: [
        "Gravação ilimitada e transcrição segura",
        "Copiloto com IA dentro da reunião (exclusivo Pro)",
        "Ata automática com IA — TL;DR, pontos-chave, action items",
        "Identificação automática de falantes em toda gravação",
        "Contexto pessoal: PDFs, notas e documentos",
        "Busca na web em tempo real para enriquecer respostas",
        "Suporte prioritário",
      ],
      cta: "Assinar Pro",
      ctaManage: "Gerenciar assinatura",
      ctaLoading: "Abrindo Stripe…",
      note: "Cobrança segura via Stripe. Cancele quando quiser.",
      error: "Algo deu errado ao abrir o Stripe. Tenta de novo em instantes.",
      cycleMonthly: "Mensal",
      cycleAnnual: "Anual",
      annualBilledAs: (total: string, pct: number) =>
        `Faturado anualmente ${total} — economize ${pct}%`,
      savingsBadge: (pct: number) => `−${pct}%`,
    },
    footer:
      "Preços em USD e EUR são indicativos; a cobrança no Stripe é em BRL. Seu banco converte ao câmbio do dia. Cancele quando quiser, sem perguntas.",
  },
  faq: {
    label: "FAQ",
    heading: "Perguntas frequentes.",
    items: [
      {
        q: "O que acontece depois dos 7 dias de trial?",
        a: "O Free continua funcionando com 1 hora/mês de transcrição e tradução seguras. O copiloto na reunião, a ata automática, a identificação de falantes, o contexto pessoal e a gravação ilimitada passam a ser exclusivos do Pro — você assina quando quiser pra trazer de volta. Nenhuma cobrança automática; a gente nunca pede cartão na hora do cadastro.",
      },
      {
        q: "O outro lado sabe que estou usando o Minuta?",
        a: "Não. O Minuta não entra na reunião e é invisível durante o screen share.",
      },
      {
        q: "Funciona em português e espanhol?",
        a: "Sim. Os idiomas em produção são inglês, português (pt-BR) e espanhol. Outros idiomas estão em beta.",
      },
      {
        q: "Minha reunião alterna entre inglês, português e espanhol. O Minuta ajuda?",
        a: "Sim. O Minuta suporta inglês, português (pt-BR) e espanhol para transcrição, tradução, atas e respostas do copiloto. O copiloto Pro pode montar a resposta no idioma que você precisa naquele momento.",
      },
      {
        q: "Traduz ao vivo durante Zoom, Teams ou Google Meet?",
        a: "Sim. O Minuta captura o áudio do sistema de qualquer app de reunião, transcreve inglês, português e espanhol de forma segura na nuvem e traduz entre os idiomas suportados em tempo real. Sem plugin, sem bot — tudo roda no seu computador.",
      },
      {
        q: "Preciso instalar algo no Zoom, Meet ou Teams?",
        a: "Não. O Minuta roda no seu computador e escuta o áudio do sistema — sem plugin, sem bot.",
      },
      {
        q: "Minhas reuniões ficam gravadas em algum lugar?",
        a: "Só se você quiser. Por padrão, só o transcript fica salvo localmente no seu dispositivo.",
      },
      {
        q: "Tem versão pra Windows ou Linux?",
        a: "Já temos para Mac e Windows. Linux está no roadmap — ainda sem data marcada.",
      },
    ],
  },
  footerCta: {
    heading: "Pronto pra responder com clareza na próxima reunião?",
    body: "Baixa o Minuta e usa na sua próxima reunião. Grátis por 7 dias, sem cartão.",
    cta: "Baixar o Minuta",
    ctaSub: "macOS · Windows · Linux em breve",
  },
  footer: {
    tagline: "zero-retention",
    support: "Suporte",
    privacy: "Privacidade",
    terms: "Termos",
    compareHeading: "Comparações",
    useCasesHeading: "Casos de uso",
    resourcesHeading: "Recursos",
  },
  relatedLinks: {
    comparisonsHeading: "Outras comparações honestas",
    comparisonsLede: "Escolha a ferramenta de reunião que combina com a sua call.",
    useCasesHeading: "Outras situações em que o Minuta brilha",
    useCasesLede: "Mais cenários em que profissionais seguem afiados em calls ao vivo em inglês, português e espanhol.",
    keepExploring: "Continue explorando",
  },
  userMenu: {
    account: "Minha conta",
    signOut: "Sair",
  },
  account: {
    heading: "Minha conta",
    youAreOn: "Você está no plano",
    plan: "",
    currentBadge: "Plano atual",
    freeNote: "O Free inclui 1 hora/mês de transcrição e tradução seguras. Assine quando quiser gravação ilimitada e copiloto.",
    proNote: "Obrigado por apoiar o Minuta. O copiloto dentro da reunião está desbloqueado.",
    manageSubscription: "Gerenciar assinatura",
    openingPortal: "Abrindo Stripe…",
    error: "Algo deu errado. Tenta de novo em instantes.",
  },
  auth: {
    shell: {
      homeLabel: "Voltar para a página inicial",
      step: (current, total, label) => `Etapa ${current}/${total} · ${label}`,
      footer:
        "Pelo cadastro você concorda com os termos e a política de privacidade. Nada de áudio é enviado pra nuvem — só seu email para criar a conta.",
    },
    login: {
      heading: "Entrar",
      subheading: "Acesse sua conta Minuta.",
      emailLabel: "Email",
      passwordLabel: "Senha",
      submitting: "Entrando…",
      submit: "Entrar",
      noAccount: "Ainda não tem conta?",
      createFree: "Criar conta grátis",
      errorEmail: "Informe um email válido.",
      errorPassword: "Informe sua senha.",
      continueGoogle: "Continuar com Google",
      orDivider: "ou",
      callbackBusy: "Finalizando login…",
      callbackError: "Não foi possível concluir o login. Tente de novo pela página inicial.",
    },
    signup: {
      headingFree: "Criar conta grátis",
      headingPro: "Criar conta Pro",
      subFree: "Sem cartão. Sem cobrança. Baixa o app e manda ver.",
      subPro: "Vamos criar seu acesso primeiro. A cobrança pelo Stripe entra em breve.",
      firstNameLabel: "Nome",
      lastNameLabel: "Sobrenome",
      emailLabel: "Email",
      passwordLabel: "Senha",
      passwordHint: "Pelo menos 8 caracteres.",
      passwordWarn: "Mínimo 8 caracteres.",
      submitting: "Criando conta…",
      submit: "Criar conta",
      codeNote: "Vamos mandar um código de 6 dígitos pro seu email.",
      stepLabel: "criar conta",
      errorEmail: "Informe um email válido.",
      errorPassword: "Senha precisa ter pelo menos 8 caracteres.",
    },
    confirm: {
      heading: "Cheque seu email",
      subPre: "Mandamos um código de 6 dígitos para",
      subPost: ".",
      yourEmail: "seu email",
      codeLabel: "Código de confirmação",
      submitting: "Confirmando…",
      submit: "Confirmar email",
      changeEmail: "← Mudar email",
      codeExpiry: "O código expira em 24h.",
      stepLabel: "confirmar email",
      errorCode: "O código tem 6 dígitos.",
      errorEmail: "Email ausente. Volte pra tela de cadastro e comece de novo.",
    },
    done: {
      heading: "Conta confirmada",
      subFree:
        "Tudo certo. Baixa o Minuta pro Mac e entra com o email e senha que você acabou de criar.",
      subPro:
        "Sua conta Pro está criada. A cobrança via Stripe será ativada em breve — enquanto isso, você está na lista de acesso antecipado.",
      downloadCta: "Baixar Minuta pro macOS",
      homeCta: "Voltar pra home",
      proNextStepsLabel: "Próximos passos — Pro",
      proNextSteps: [
        "Por ora, o app funciona igual à conta Free enquanto integramos o Stripe.",
        "Você vai receber um email quando a cobrança estiver ativa — aí é só autorizar.",
        "Dúvidas ou problemas? Entre em contato com o suporte.",
      ],
      troubleNote:
        "Problemas pra entrar? Tenta redefinir a senha pelo app — a tela de login tem o link.",
    },
  },
  download: {
    eyebrow: "App desktop privado",
    heading: "Baixar Minuta",
    autoArm64:
      "Parece que você está num Apple Silicon. Baixe a versão macOS destacada e abra o Minuta antes da próxima reunião.",
    autoX64:
      "Parece que você está num Mac Intel. Baixe a versão macOS destacada e abra o Minuta antes da próxima reunião.",
    autoWindows:
      "Parece que você está no Windows. O instalador recomendado está em destaque abaixo.",
    autoWindowsArm64:
      "Parece que você está no Windows on ARM. O instalador ARM64 está em destaque abaixo.",
    autoUnknown:
      "Escolha a versão que combina com o seu computador. Não precisa de conta para baixar.",
    supportedKicker: "Passo 1",
    supportedHeading: "Escolha sua plataforma",
    supportedBody:
      "O Minuta tem builds desktop nativos para macOS e Windows. A opção detectada aparece em destaque, mas todas continuam disponíveis para notebooks de trabalho e instalações em outro dispositivo.",
    macPickerLabel: "macOS",
    winPickerLabel: "Windows",
    archArm64: "Apple Silicon",
    archArm64Hint: "M1 · M2 · M3 · M4",
    archX64: "Mac Intel",
    archX64Hint: "Macs pré-2021",
    winSetup: "Instalador (recomendado)",
    winSetupHint: "Windows 10/11 · x64 · .exe",
    winPortable: "Portátil",
    winPortableHint: "Sem instalação · x64 · roda direto da pasta",
    winSetupArm64: "Instalador · ARM64",
    winSetupArm64Hint: "Windows 11 ARM · arm64 · .exe",
    winPortableArm64: "Portátil · ARM64",
    winPortableArm64Hint: "Sem instalação · arm64 · roda direto da pasta",
    firstRunKicker: "Passo 2",
    firstRunHeading: "Abertura instantânea e leve",
    firstRunBody:
      "O Minuta roda os modelos pesados de transcrição e IA na nuvem, sem downloads gigantes de modelos. A inicialização é imediata e consome o mínimo de recursos.",
    firstRunItems: [
      "App desktop super leve: menos de 100 MB de espaço.",
      "Inundado de velocidade: transcrição e resumos rápidos hospedados no Groq (Whisper/Llama).",
      "Funciona com Zoom, Teams, Google Meet e qualquer app de reunião que toque áudio no seu computador.",
    ],
    securityKicker: "Nota de confiança",
    securityHeading: "Sem bot, pipeline seguro e retenção temporária",
    securityBody:
      "O Minuta não coloca bot na sua reunião. A captura de áudio fica local no seu computador, e a transcrição/IA rodam por APIs em nuvem seguras e de retenção restrita.",
    securityItems: [
      "Nenhum bot entra na call e nada aparece para os outros participantes.",
      "Retenção temporária: não salvamos seu áudio ou transcrições permanentemente e nunca usamos seus dados para treinar modelos.",
      "A versão Mac é assinada e notarizada; o instalador Windows é assinado de fábrica para integração direta.",
    ],
    troubleshootingKicker: "Se o sistema bloquear o app",
    troubleshootingHeading: "Avisos na primeira abertura",
    troubleshootingBody:
      "Estas notas ficam abaixo do download principal porque a maioria dos usuários só precisa delas depois de instalar. Elas são esperadas no empacotamento beta atual e não mudam o fluxo de download.",
    homeCta: "Voltar pra home",
    footnote: "macOS 13+ / Windows 10 21H2+ · link assinado expira em 5 minutos",
    gatekeeperLabel: "Instalar no macOS",
    gatekeeperExplain:
      "Abra o DMG, arraste o Minuta para Aplicativos e depois abra pelo Finder. A versão Mac é assinada e notarizada; não precisa rodar comando no Terminal.",
    winSmartScreenLabel: "Se o Windows bloquear a instalação",
    winSmartScreenExplain:
      "A versão beta para Windows ainda não tem assinatura de código, então o SmartScreen pode mostrar um aviso de app não reconhecido na primeira instalação.",
    winSmartScreenSteps: [
      "Clique em Mais informações no aviso do SmartScreen.",
      "Confirme que o editor aparece como Editor desconhecido.",
      "Clique em Executar assim mesmo para abrir o instalador.",
    ],
    detectedBadge: "Detectado",
    comingSoonBadge: "Em breve",
    linuxPickerLabel: "Linux",
    linuxComingSoon:
      "A versão pra Linux tá no roadmap — deve sair logo depois que a gente fechar o primeiro ciclo de release do Windows. Quer receber email quando sair? Cria uma conta e a gente avisa.",
  },
  billing: {
    done: {
      heading: "Pagamento concluído",
      subProcessing:
        "Estamos ativando seu plano Pro. O webhook do Stripe demora uns segundos — essa página atualiza sozinha.",
      subReady:
        "Seu plano Pro está ativo. Abra o Minuta e entre de novo se o app já estiver aberto, pra liberar o copiloto.",
      openApp: "Abrir Minuta",
      homeCta: "Voltar pra home",
      refreshCta: "Atualizar status",
      error: "Ainda não conseguimos confirmar o pagamento. Tenta atualizar em instantes.",
    },
    cancelled: {
      heading: "Compra cancelada",
      sub: "Nenhuma cobrança foi feita. Pode tentar de novo quando quiser — nada foi perdido.",
      retryCta: "Tentar de novo",
      homeCta: "Voltar pra home",
    },
    proPurchase: {
      signedOut: "Entra na sua conta pra concluir a compra do Pro.",
      cta: "Concluir pagamento",
      ctaSignIn: "Entrar pra pagar",
      ctaLoading: "Abrindo Stripe…",
      error: "Algo deu errado ao abrir o Stripe. Tenta de novo em instantes.",
    },
  },
  launch: {
    hero: {
      eyebrow: "Ao vivo no Product Hunt · 14/05/2026",
      h1: "Pare de travar quando a pergunta chega.",
      sub: "Um copiloto multilíngue pra sua reunião. Captura segura. Sem bot.",
      cta: "Começar grátis",
      ctaSub: "7 dias com tudo · sem cartão",
      ctaSecondary: "Ler o recado do fundador",
    },
    tldr: {
      heading: "O Minuta em 30 segundos",
      body:
        "O Minuta é um app para Mac/Windows que transforma qualquer chamada do Zoom, Teams ou Google Meet num copiloto em tempo real para reuniões em inglês, português e espanhol. Ele captura o áudio localmente, transcreve em nuvem através de APIs de alta velocidade e elabora respostas no idioma que você precisa, no seu nível técnico, baseadas em PDFs e anotações carregadas. Sem bot na chamada, invisível para o outro lado. Setup instantâneo com um instalador leve de 100 MB (sem downloads de 5 GB). Feito para profissionais que precisam responder com clareza enquanto a reunião ainda está acontecendo.",
    },
    video: {
      heading: "60 segundos, do começo ao fim",
      sub: "Uma call real. A sidebar do Minuta. Sem cortes.",
      embedUrl: "",
      caption: "Se o embed não carregar, assista no Loom →",
    },
    founderNote: {
      heading: "Sou o Mark. Hoje é o dia do launch — AMA.",
      body:
        "Construí o Minuta porque sou engenheiro ESL e perdi cliente em call técnica — não porque eu não sabia a resposta, mas porque não conseguia montá-la em inglês rápido o suficiente. Estou tocando solo. Vou estar respondendo no Product Hunt e no email o dia inteiro. Me conta o que tá faltando — eu leio tudo.",
      signature: "— Mark",
    },
    discount: {
      eyebrow: "Só hoje no Product Hunt · termina 21/05/2026",
      headline: "Empilhe HUNT30 no plano anual",
      price: "€67,20 / ano",
      priceWas: "em vez de €108",
      sub: "O anual já economiza 20%. HUNT30 empilha mais 30% no primeiro ano. Ou use no mensal: €6,30/mês, travado pra sempre.",
      code: "HUNT30",
      codeLabel: "Código",
      button: "Pegar o desconto do launch",
      buttonSub: "Aplique HUNT30 no checkout",
    },
    faq: {
      heading: "Perguntas comuns sobre o launch",
      items: [
        {
          q: "O Minuta é open source?",
          a: "Ainda não. O app desktop é closed-source hoje, mas o pesado roda em modelos abertos que você pode auditar: Whisper pra transcrição, Llama / Qwen pro copiloto, pyannote pra diarização. O roadmap prevê abrir partes do pipeline quando a API estabilizar.",
        },
        {
          q: "Como a privacidade é garantida na prática?",
          a: "O áudio é capturado localmente no seu computador e enviado por conexões seguras e com retenção limitada para transcrição e IA (Groq Whisper e Llama). Não armazenamos o áudio ou transcrições nos nossos servidores e nunca treinamos modelos com os seus dados. Somente seu e-mail de login é mantido.",
        },
        {
          q: "Por que não usar Otter ou Granola?",
          a: "Otter e Granola são bons notetakers de nuvem para times que querem principalmente um transcript. O Minuta é pra quando você precisa responder em uma conversa técnica ao vivo — em inglês, português ou espanhol — enquanto o outro lado ainda espera. Problema diferente. Mantemos uma comparação honesta no site.",
        },
        {
          q: "O que tem no roadmap?",
          a: "Roadmap público: build pra Linux (Q3 2026), coaching in-app (feedback pós-call das suas respostas), plano time com perfil compartilhado e CLI pra transcrição headless. Tudo o que mais valer a pena, você vota no roadmap público. A gente entrega o que o usuário pede, na ordem.",
        },
        {
          q: "Como funcionam o free e o trial Pro de verdade?",
          a: "Cadastre-se — 7 dias com tudo liberado, copiloto incluso. Sem cartão. Depois do dia 7, o Free inclui 1 hora/mês de transcrição e tradução seguras. O copiloto na reunião, ata, identificação de falantes, contexto pessoal e gravação ilimitada vão pro Pro (€9/mês, ou €7,50/mês no anual). Cancele quando quiser no Stripe.",
        },
        {
          q: "Quão rápido é o setup?",
          a: "O setup é instantâneo. Como processamos a transcrição e IA na nuvem, o instalador do desktop tem menos de 100 MB. Você pode baixar, criar sua conta e começar sua primeira gravação em menos de um minuto, sem downloads massivos.",
        },
      ],
    },
    banner: {
      text: "Ao vivo no Product Hunt · 30% off no Pro pra sempre com HUNT30",
      cta: "Ver o launch →",
      dismissAriaLabel: "Fechar banner do launch",
    },
  },
  teamsWaitlist: {
    seoTitle: "Minuta pra times — entre na waitlist",
    seoDescription:
      "Perfil compartilhado, biblioteca de docs do time e billing centralizado. Conta do seu time e o Mark fala com você pessoalmente quando o plano time sair.",
    eyebrow: "Plano time · acesso antecipado",
    heading: "Um copiloto de reunião feito pro time inteiro",
    subheading:
      "Hoje o Minuta é um plano Pro por assento. O plano time adiciona perfil compartilhado (do jeito que o time fala de si mesmo), biblioteca de docs do time, billing centralizado e uso por assento. Deixa seu email corporativo e uma linha sobre o time — o Mark fala com você pessoalmente assim que sair.",
    nameLabel: "Seu nome",
    namePlaceholder: "Mark Gerald",
    emailLabel: "Email de trabalho",
    emailPlaceholder: "voce@empresa.com",
    teamSizeLabel: "Quantas pessoas no time?",
    teamSizeOptions: [
      { value: "2-5", label: "2–5" },
      { value: "6-15", label: "6–15" },
      { value: "16-50", label: "16–50" },
      { value: "50+", label: "50+" },
    ],
    notesLabel: "O que o seu time faz? (opcional)",
    notesPlaceholder: "Sales engineering em SaaS B2B, clientes US na maioria…",
    cta: "Me coloca na waitlist",
    ctaLoading: "Enviando…",
    privacyNote:
      "Usamos só pra te avisar quando o plano time sair e fazer 1–2 perguntas de follow-up. Sem lista de marketing, sem revenda.",
    success: "Você tá na lista. O Mark te manda um email pessoal antes do plano time sair.",
    error: "Não conseguimos enviar o formulário agora. Tenta de novo em instantes.",
    invalidEmail: "Digite um email de trabalho válido.",
    afterSubmit: {
      heading: "Valeu — você tá na lista.",
      body: "O Mark lê cada entrada. Espera um email pessoal quando o plano time tiver pronto (e possivelmente uma ou duas perguntas rápidas antes disso).",
      ctaHome: "Voltar pro Minuta",
      ctaPricing: "Ver o plano Pro por assento",
    },
  },
};
